import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';

import Link from '../../Links/Link/Link';
import { withBaseComponent } from '../hoc/withBaseComponent';

const StoryblokPassBenefitsPresetComponent = ({ blok }) => {
  if (!blok || typeof blok !== 'object') {
    return null;
  }

  const { dataSource } = blok || {};
  if (!dataSource || typeof dataSource !== 'object') {
    return null;
  }

  const {
    heading = '',
    subHeading = '',
    buttonLabel = '',
    images = '',
    buttonSlug = '',
  } = dataSource;

  // Helper function to extract slug and rest
  const getSlugAndRest = (slugString) => {
    if (typeof slugString === 'string' && slugString.includes('/')) {
      const [slug, ...restParts] = slugString.split('/');
      const rest = restParts.join('/');
      return [slug || '', rest || undefined];
    } else {
      return [slugString || '', undefined];
    }
  };

  const [slug, rest] = getSlugAndRest(buttonSlug);

  // Parse the images string into an array
  const imageUrls = images
    ? images
      .split(';')
      .map((url) => url.trim())
      .filter((url) => url !== '')
    : [];

  return (
    <Box sx={{ padding: 4 }}>
      {/* Heading */}
      {heading ? (
        <Typography component="h2" gutterBottom variant="h4">
          {heading}
        </Typography>
      ) : null}

      {/* Subheading */}
      {subHeading ? (
        <Typography gutterBottom variant="body1">
          {subHeading}
        </Typography>
      ) : null}

      {/* Button */}
      {buttonLabel && slug ? (
        <Box sx={{ my: 2 }}>
          <Button
            color="primary"
            component={Link}
            to={{
              name: 'StoryblokPage',
              params: { slug, ...(rest && { rest }) },
            }}
            variant="contained"
          >
            {buttonLabel}
          </Button>
        </Box>
      ) : null}

      {/* Images */}
      {imageUrls.length > 0 ? (
        <Box sx={{ mt: 4 }}>
          <Grid container spacing={2}>
            {imageUrls.map((url, index) => (
              <Grid key={index} size={{ md: 4, sm: 6, xs: 12 }}>
                <Box
                  alt={`Benefit ${index + 1}`}
                  component="img"
                  src={url}
                  sx={{ width: '100%', height: 'auto' }}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      ) : null}
    </Box>
  );
};

StoryblokPassBenefitsPresetComponent.displayName = 'StoryblokPassBenefitsPreset';
const StoryblokPassBenefitsPreset = memo(withBaseComponent(StoryblokPassBenefitsPresetComponent));
export default StoryblokPassBenefitsPreset;
